import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { UnsavedChangesProvider } from "@/lib/unsavedChanges";
import { LogOut, Shield, Building2, FileText, Shapes } from "lucide-react";
import { SupportNotificationsProvider } from "@/lib/SupportNotificationsContext";
import { SupportNavLink } from "@/components/SupportNavLink";

export default function SuperAdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <SupportNotificationsProvider user={user}>
    <div className="flex flex-col md:flex-row min-h-screen bg-[#FAFAFA]" data-testid="superadmin-layout">
      <aside className="w-full md:w-64 bg-[#FFFFFF] text-[#000000] flex flex-col shrink-0">
        <div className="px-4 py-3 md:px-6 md:py-8 border-b border-black/10">
          <div className="flex items-center gap-2">
            <Shield className="w-4 h-4 text-[#525252]" strokeWidth={1.5} />
            <div className="text-[10px] tracking-[0.28em] uppercase text-[#525252]">Superadmin</div>
          </div>
          <div className="font-serif text-xl md:text-2xl mt-1 md:mt-2">Cosmely</div>
        </div>
        <nav className="flex flex-wrap md:block py-1 md:py-6">
          <NavLink to="/admin"
            end
            className={({isActive}) => `block px-3 md:px-6 py-2.5 md:py-3 text-xs md:text-sm hover:bg-[#FAFAFA] ${isActive ? "border-l-2 border-black bg-[#FAFAFA]" : ""}`}
            data-testid="nav-admin-tenants">
            <Building2 className="inline w-4 h-4 mr-3" strokeWidth={1.5} />Abbonamenti
          </NavLink>
          <NavLink to="/admin/contracts"
            className={({isActive}) => `block px-3 md:px-6 py-2.5 md:py-3 text-xs md:text-sm hover:bg-[#FAFAFA] ${isActive ? "border-l-2 border-black bg-[#FAFAFA]" : ""}`}
            data-testid="nav-admin-policies">
            <FileText className="inline w-4 h-4 mr-3" strokeWidth={1.5} />Contratti e condizioni
          </NavLink>
          <NavLink to="/admin/pictograms"
            className={({isActive}) => `block px-3 md:px-6 py-2.5 md:py-3 text-xs md:text-sm hover:bg-[#FAFAFA] ${isActive ? "border-l-2 border-black bg-[#FAFAFA]" : ""}`}
            data-testid="nav-admin-pictograms">
            <Shapes className="inline w-4 h-4 mr-3" strokeWidth={1.5} />Pittogrammi
          </NavLink>
          <SupportNavLink admin />
        </nav>
        <div className="px-4 py-2 md:px-6 md:py-5 border-t border-black/10 flex flex-wrap items-center justify-between gap-2 md:block">
          <div className="text-[11px] text-[#525252] truncate max-w-[210px] md:max-w-full md:mb-2" data-testid="admin-account-email">{user?.email}</div>
          <button onClick={() => { logout(); nav("/login"); }}
            className="text-[11px] tracking-[0.24em] uppercase text-[#000000] hover:text-[#525252] flex items-center"
            data-testid="admin-logout-btn">
            <LogOut className="w-3 h-3 mr-2" strokeWidth={1.5} /> Esci
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-x-clip min-w-0">
        <UnsavedChangesProvider>
          <Outlet />
        </UnsavedChangesProvider>
      </main>
    </div>
    </SupportNotificationsProvider>
  );
}
